import React, { useState, useEffect } from 'react';
import { connect } from "trim-redux";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../../config/design/styles';
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AddressHolder from "../../../../components/address/map/AddressHolder";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {calculateShopRadius} from "../../../../../config/values";
import {isAdmin} from "../../../../../config/Permissions";

const ShopAddress = (props) => {
    const navigation = useNavigate();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { id: paramId } = useParams();

    let id = paramId;
    if(!id && !props.create){
        if(!!props.user?.shop?.id){
            id = props.user.shop.id;
        }
    }

    const [radius, setRadius] = useState(null);
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };

    useEffect(() => {
        if(!id && !props.create){
            navigation('/');
            return;
        }
        if(!id){
            return;
        }
        axios.get(`${defaultVariables.url}/shops/get/${id}`, config)
            .then(response => {
                setRadius(calculateShopRadius(response.data));
            })
            .catch(error => {
                console.error("Error fetching shop data for radius:", error);
            });
    }, [id]);

    const handleAddressDone = () => {
        enqueueSnackbar(t('detailsSet'), { variant: 'success' });
    };

    if (!id) {
        return null;
    }

    return (
        <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{xs:12}}>
                <AddressHolder
                    vendor
                    shop_id={id}
                    handleAddressDone={handleAddressDone}
                    radius={radius}
                    allowGoogleMapsLink={isAdmin()}
                />
            </Grid>
        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(ShopAddress));
